import { render, staticRenderFns } from "./courseDjustment.vue?vue&type=template&id=7f467cfe&scoped=true"
import script from "./courseDjustment.vue?vue&type=script&lang=js"
export * from "./courseDjustment.vue?vue&type=script&lang=js"
import style0 from "./courseDjustment.vue?vue&type=style&index=0&id=7f467cfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f467cfe",
  null
  
)

export default component.exports